'use strict'

module.exports = { version: '9.7.0' }
